import { ZillowMapControl } from '@zillow/zillow-map-control';
import { type MapBounds, type MapCenter } from '../../layouts/MainPageLayout/MainLayoutContext';

export const Map = ({
  children,
  center,
  zoom,
  bounds,
  setCenter,
  setZoom,
  setBounds,
  freezeMap,
}: {
  children: React.ReactNode;
  center: MapCenter;
  zoom: number;
  bounds: MapBounds;
  setCenter: (center: MapCenter) => void;
  setZoom: (zoom: number) => void;
  setBounds: (bounds: MapBounds) => void;
  freezeMap?: boolean;
}) => {
  return (
    <ZillowMapControl
      id="customer-analytics-map"
      apiKey={__GMAPS_API_KEY__}
      boundingRect={bounds}
      onBoundsChange={({
        center: newCenter,
        zoom: newZoom,
        bounds: newBounds,
      }: {
        center: MapCenter;
        zoom: number;
        bounds: MapBounds;
      }) => {
        if (newCenter.eastWestLng !== center.eastWestLng || newCenter.northSouthLat !== center.northSouthLat) {
          setCenter(newCenter);
        }
        if (newZoom !== zoom) {
          setZoom(newZoom);
        }
        if (
          newBounds.eastLng !== bounds?.eastLng ||
          newBounds.northLat !== bounds?.northLat ||
          newBounds.southLat !== bounds?.southLat ||
          newBounds.westLng !== bounds?.westLng
        ) {
          setBounds(newBounds);
        }
      }}
      minZoom={3}
      maxZoom={15}
      freezeMap={freezeMap}
      showDefaultZoomControls={!freezeMap}
    >
      {children}
    </ZillowMapControl>
  );
};
